/* =============================================
   CHLOÉ STORA STUDIO — Theme JS
   ============================================= */

document.addEventListener('DOMContentLoaded', () => {

  // ── Header scroll behavior ──────────────────
  const header = document.querySelector('.site-header');
  const heroSection = document.querySelector('.hero-section');

  if (header) {
    const isTransparent = heroSection !== null;

    if (isTransparent) {
      header.classList.add('header-transparent');
    }

    window.addEventListener('scroll', () => {
      if (window.scrollY > 40) {
        header.classList.add('scrolled');
        header.classList.remove('header-transparent');
      } else {
        header.classList.remove('scrolled');
        if (isTransparent) header.classList.add('header-transparent');
      }
    }, { passive: true });
  }

  // ── Mobile menu ─────────────────────────────
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileNav  = document.querySelector('.mobile-nav');
  const mobileClose = document.querySelector('.mobile-nav-close');

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      mobileNav.classList.add('open');
      document.body.style.overflow = 'hidden';
    });

    [mobileClose, mobileNav].forEach(el => {
      if (!el) return;
      el.addEventListener('click', (e) => {
        if (e.target === mobileNav || e.target === mobileClose || e.currentTarget === mobileClose) {
          mobileNav.classList.remove('open');
          document.body.style.overflow = '';
        }
      });
    });
  }

  // ── Cart drawer ─────────────────────────────
  const cartOverlay  = document.querySelector('.cart-overlay');
  const cartDrawer   = document.querySelector('.cart-drawer');
  const cartClose    = document.querySelector('.cart-close');
  const cartTriggers = document.querySelectorAll('[data-cart-trigger]');

  function openCart() {
    cartOverlay?.classList.add('open');
    cartDrawer?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    cartOverlay?.classList.remove('open');
    cartDrawer?.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartTriggers.forEach(t => t.addEventListener('click', (e) => {
    e.preventDefault();
    openCart();
  }));

  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  // ── Add to cart ──────────────────────────────
  const atcForm = document.querySelector('.product-atc-form');
  if (atcForm) {
    atcForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = atcForm.querySelector('.btn-atc');
      const originalText = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;

      const formData = new FormData(atcForm);
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        });
        if (res.ok) {
          btn.textContent = 'Added';
          await updateCartDrawer();
          setTimeout(() => openCart(), 300);
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        }
      } catch (err) {
        btn.textContent = originalText;
        btn.disabled = false;
      }
    });
  }

  // ── Variant selection ────────────────────────
  function getSelectedOptions() {
    const selected = [];
    document.querySelectorAll('.variant-options').forEach(group => {
      const active = group.querySelector('.variant-option.selected');
      if (active) selected.push(active.dataset.value);
    });
    return selected;
  }

  function updateVariantId() {
    if (!window.productVariants) return;
    const selected = getSelectedOptions();
    const match = window.productVariants.find(v =>
      v.options.length === selected.length &&
      v.options.every((opt, i) => opt === selected[i])
    );
    const input = document.getElementById('VariantId');
    const btn = document.querySelector('.btn-atc');
    if (match && input) {
      input.value = match.id;
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? 'Ajouter au panier' : 'Épuisé';
      }
    }
  }

  const variantOptions = document.querySelectorAll('.variant-option');
  variantOptions.forEach(opt => {
    opt.addEventListener('click', () => {
      const group = opt.closest('.variant-options');
      group?.querySelectorAll('.variant-option').forEach(o => o.classList.remove('selected'));
      opt.classList.add('selected');
      updateVariantId();
    });
  });

  updateVariantId();

  // ── Accordion ────────────────────────────────
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const isOpen = trigger.classList.contains('open');
      // close all
      document.querySelectorAll('.accordion-trigger').forEach(t => {
        t.classList.remove('open');
        t.nextElementSibling?.classList.remove('open');
      });
      if (!isOpen) {
        trigger.classList.add('open');
        trigger.nextElementSibling?.classList.add('open');
      }
    });
  });

  // ── Scroll reveal ─────────────────────────────
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    revealEls.forEach(el => observer.observe(el));
  }

  // ── Cart count update ─────────────────────────
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'inline-block' : 'none';
      });
    } catch (e) {}
  }

  async function updateCartDrawer() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const body = document.querySelector('.cart-drawer-body');
      const subtotalEl = document.querySelector('.cart-subtotal-amount');

      if (body) {
        if (cart.items.length === 0) {
          body.innerHTML = `<div class="cart-empty"><p>Your cart is empty</p><a href="/collections/all" class="btn btn-dark">Shop Now</a></div>`;
        } else {
          body.innerHTML = cart.items.map((item, index) => `
            <div class="cart-item">
              <div class="cart-item-img">
                <img src="${item.image}" alt="${item.product_title}" loading="lazy">
              </div>
              <div class="cart-item-info">
                <p class="cart-item-name">${item.product_title}</p>
                <p class="cart-item-variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</p>
                <p class="cart-item-price">${formatMoney(item.final_line_price)}</p>
                <div style="display:flex;align-items:center;gap:10px;margin-top:10px;">
                  <button onclick="updateCartQty(${index + 1}, ${item.quantity - 1})"
                    style="width:24px;height:24px;border:1px solid var(--color-border);background:none;cursor:pointer;font-size:16px;display:flex;align-items:center;justify-content:center;color:var(--color-text);">−</button>
                  <span style="font-size:13px;min-width:16px;text-align:center;">${item.quantity}</span>
                  <button onclick="updateCartQty(${index + 1}, ${item.quantity + 1})"
                    style="width:24px;height:24px;border:1px solid var(--color-border);background:none;cursor:pointer;font-size:16px;display:flex;align-items:center;justify-content:center;color:var(--color-text);">+</button>
                </div>
              </div>
              <button onclick="updateCartQty(${index + 1}, 0)"
                 aria-label="Supprimer"
                 style="background:none;border:none;display:flex;align-items:center;justify-content:center;width:28px;height:28px;color:var(--color-text-muted);flex-shrink:0;align-self:flex-start;cursor:pointer;transition:color 0.2s;"
                 onmouseover="this.style.color='var(--color-text)'"
                 onmouseout="this.style.color='var(--color-text-muted)'">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
                  <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
            </div>
          `).join('');
        }
      }

      if (subtotalEl) {
        subtotalEl.textContent = formatMoney(cart.total_price);
      }

      updateCartCount();
    } catch (e) {}
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  updateCartCount();


  // ── Quick Add (global, used by collection grid) ──
  window.quickAddVariant = async function(variantId, btn) {
    const original = btn.textContent;
    btn.textContent = '✓';
    btn.classList.add('added');
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (res.ok) {
        await updateCartDrawer();
        setTimeout(() => {
          btn.textContent = original;
          btn.classList.remove('added');
          openCart();
        }, 400);
      }
    } catch(e) {
      window.location.href = '/cart';
    }
  };

  // ── Update cart quantity ─────────────────────
  window.updateCartQty = async function(line, quantity) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      await updateCartDrawer();
    } catch(e) {}
  };

  // ── Page fade in ─────────────────────────────
  document.querySelector('main')?.classList.add('page-transition');

});
